var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinaSendMessageArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3046 10.2823C16.3049 10.5398 16.3572 10.7945 16.4586 11.0311L19.6606 18.5206C19.6988 18.61 19.7088 18.709 19.6891 18.8042C19.6694 18.8995 19.6211 18.9864 19.5506 19.0534C19.4801 19.1204 19.3908 19.1642 19.2946 19.179C19.1985 19.1938 19.1002 19.1788 19.0128 19.136L1.82283 10.7096C1.74152 10.6714 1.67276 10.6109 1.6246 10.5351C1.57644 10.4593 1.55086 10.3713 1.55086 10.2815C1.55086 10.1917 1.57644 10.1037 1.6246 10.0279C1.67276 9.95213 1.74152 9.8916 1.82283 9.85345L19.0128 1.427C19.1001 1.38425 19.1985 1.36925 19.2946 1.38402C19.3908 1.39878 19.4801 1.4426 19.5506 1.50959C19.6211 1.57658 19.6694 1.66353 19.6891 1.75879C19.7088 1.85404 19.6988 1.95302 19.6606 2.04246L16.4572 9.53324C16.3563 9.77007 16.3044 10.0249 16.3046 10.2823ZM16.3046 10.2823L1.55587 10.2808",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinaSendMessageArrow);
export default __webpack_public_path__ + "v10/media/bina-send-message-arrow.8d94a60bce9b681dec722a1e6d1c0fd4.svg";
export { ForwardRef as ReactComponent };